// @flow

import {  
  UPLOAD_SUCCESS,  
  UPLOAD_FAIL,
  UPLOAD_PROGRESS,
  UPLOAD_FILE_NAME,
  UPLOAD_PAUSE,
  UPLOAD_RESUME,  
  UPLOAD_CANCEL,
  UPLOAD_CLEAR_STATUS,
  UPLOAD_MESSAGE
} from './../types/upload';

export const uploadSuccess = (filesCount) => ({
  type: UPLOAD_SUCCESS,
  filesCount: filesCount
});

export const uploadFail = (message) => ({
  type: UPLOAD_FAIL,
  [UPLOAD_MESSAGE]: message,
});

export const uploadProgress = (progress, fileName) => ({
  type: UPLOAD_PROGRESS,
  [UPLOAD_PROGRESS]: progress,
  [UPLOAD_FILE_NAME]: fileName
});

export const uploadPause = () => ({
  type: UPLOAD_PAUSE,
});

export const uploadResume = () => ({
  type: UPLOAD_RESUME,
});

export const uploadCancel = () => ({
  type: UPLOAD_CANCEL,
});

export const uploadClearStatus = () => ({
  type: UPLOAD_CLEAR_STATUS
});


// WEBPACK FOOTER //
// ./src/actions/upload.jsx